import { render, staticRenderFns } from "./AdminOrganization.vue?vue&type=template&id=2f84c01f&"
import script from "./AdminOrganization.vue?vue&type=script&lang=js&"
export * from "./AdminOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports